"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uzbekTranslations = void 0;
var _types = require("../../../types");
const uzbekTranslations = exports.uzbekTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Kechirasiz!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Orqaga',
  [_types.ErrorPageTranslationKey.text]: 'Bu sahifa hozircha ishlamayapti',
  [_types.ErrorPageTranslationKey.notFound]: 'Siz qidirayotgan sahifa mavjud emas',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Siz kirishga harakat qilayotgan sahifa cheklangan va barcha shartlarga javob bermagan.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: "Iltimos, Oriflame qo'llab-quvvatlash jamoasiga elektron pochta orqali murojaat qiling:",
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'So‘ralgan URL rad etildi!'
};
